import React from "react";
import { getPropertyValue } from "../../utils";
import styles from "./HeatMap.module.sass";
const HeatMap = props => {
  const {
    heatMapList,
    fiscalYear,
    type
  } = props;
  const aggregatedDataList = typeof heatMapList === "object" ? heatMapList : JSON.parse(heatMapList);
  const list = aggregatedDataList[fiscalYear] || new Array(12).fill(0);
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["container"]}`
  }, list && list.length ? list.slice(0, 12).map((elem, index) => {
    const color = heatMapColorsByTheme(elem);
    return /*#__PURE__*/React.createElement("div", {
      id: `${index}`,
      style: {
        background: color
      },
      key: `${index}_${elem}`,
      className: `${type === "colorHeatMap" ? elem === 0 ? styles["empty"] : elem === 1 ? styles["filled"] : styles["collisions"] : styles["border-only"]} `
    }, type !== "colorHeatMap" ? elem : " ");
  }) : null);
};
export default HeatMap;
function heatMapColorsByTheme(value) {
  const position = value === 0 ? 2 : value === 1 ? 0 : 1;
  const heatMapColors = [getPropertyValue("--chart-primary-color").trim(), getPropertyValue("--chart-secondary-color").trim(), getPropertyValue("--chart-third-color").trim()];
  return heatMapColors[position];
}